export const START = 'appState/START';

export const SET_CURRENT_RESTAURANT = 'appState/SET_CURRENT_RESTAURANT';

export const SET_CURRENT_RESTAURANT_FROM_CART = 'appState/SET_CURRENT_RESTAURANT_FROM_CART';

export const CAUTH_CLEAR_CUSTOMER_DATA = 'appState/CAUTH_CLEAR_CUSTOMER_DATA';
export const DONE_CAUTH_CLEAR_CUSTOMER_DATA = 'appState/DONE_CAUTH_CLEAR_CUSTOMER_DATA';
